import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Btn,
  CustomDataTableHeader,
  CustomMultiSelect,
  CustomPanel,
  PageHeader,
  Periodo,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import useListagemTagPallet, { LOAD_MESSAGE, STATUS_TAG_PALLET } from './ListagemTagPalletHook'
import { formatIsoDateToLocale } from '../../../../services/util/date.service'

function ListagemTagPallet({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useListagemTagPallet()
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.LOADING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPalletAreaTag(
          state.periodo.dataInicial,
          state.periodo.dataFinal,
          selectedTp,
        )
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>3.20 - LISTAGEM DE TAG PALLET</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <>
            <div className="p-grid" style={{ marginBottom: 20 }}>
              <div className="p-col-6 p-md-4">
                <Periodo
                  btnEnabled={selectedTp}
                  periodoInicial={state.periodo.dataInicial}
                  periodoFinal={state.periodo.dataFinal}
                  onPesquisar={(dataInicial, dataFinal) =>
                    localDispatch.getPalletAreaTag(dataInicial, dataFinal, selectedTp)
                  }
                />
              </div>
              <div className="p-col-2">
                <CustomMultiSelect
                  filter={true}
                  optionLabel="name"
                  options={STATUS_TAG_PALLET}
                  value={state.selectedStatus}
                  label="Status :"
                  onChange={value => localDispatch.onStatusChange(value)}
                />
              </div>
              <div className="p-col-2" style={{ marginTop: 33 }}>
                <Btn
                  onClick={() => localDispatch.onBtnExportarExcelClick(state.filteredPalletArea)}
                >
                  Exportar Excel
                </Btn>
              </div>
              <div className="p-col-12">
                <DataTable
                  header={<CustomDataTableHeader onChange={setGlobalFilter} />}
                  globalFilter={globalFilter}
                  value={state.filteredPalletArea}
                  emptyMessage="Não existe tag pallet para o período selecionado"
                  paginator
                  rows={10}
                >
                  <Column field="id" header="Código" style={tableCellCentered(80)} />
                  <Column
                    field="picking_id"
                    header="Picking - Código"
                    style={tableCellCentered(200)}
                  />
                  <Column field="picking_name" header="Picking - Descrição" />
                  <Column field="status" header="Status" style={tableCellCentered(170)} />
                  <Column field="qte_caixas" header="Qte. Caixas" style={tableCellCentered(80)} />
                  <Column field="company_name" header="Empresa" />
                  <Column
                    field="created_at"
                    header="Data Criação"
                    style={tableCellCentered(170)}
                    body={item =>
                      formatIsoDateToLocale(item.created_at).toFormat('dd/MM/yy HH:mm:ss')
                    }
                  />
                </DataTable>
              </div>
            </div>
          </>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ListagemTagPallet))
